import { render, staticRenderFns } from "./Rattachment.vue?vue&type=template&id=f0b5294e"
import script from "./Rattachment.vue?vue&type=script&lang=js"
export * from "./Rattachment.vue?vue&type=script&lang=js"
import style0 from "./Rattachment.vue?vue&type=style&index=0&id=f0b5294e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports